<template>
  <div class="container" style="height:100%;">
    <div style="overflow: hidden;">
      <el-button type="primary" size="mini" @click="referenceClick" style="float: right;">引用内容</el-button>
    </div>
    <div class="reain-detail-page container">
      <div style="height:800px;width:75%;" v-if="newFlag">
        <div style="margin:12px 0;font-size: 14px;cursor: pointer;" @click="cancelAdd">
          < 返回</div>
            <!-- <div style="width:100%;height:100%;"> -->
            <div style="border:1px solid;height:800px;" :style="{ width: newFlag ? '100%' : '50%' }">
              <iframe
                :src="baseUrl + '#/content-square/search/index?isFrame=1&client_id=' + CLIENT_ID + '&access_token=' + Authorization"
                width="100%" height="100%" frameborder="0"></iframe>
              <!-- <iframe src="https://sit-medkb-admin.youlanai.cn/#/content-square/search/index?isFrame=1&client_id=dsicm_sit&access_token=aa39a66c-7d5e-4a9c-8290-b9c554202fc0" width="100%" height="100%" frameborder="0"></iframe> -->
            </div>
        </div>
        <div style="display:flex;" :style="{ width: newFlag ? '50%' : '100%' }">
          <div class="left-menu">
            <div class="group-btn" v-if="treeList && treeList.length">
              <el-button type="primary" size="mini" @click="addNode(1)" :disabled="!Boolean(currentData.id)">+同级
              </el-button>
              <el-button type="primary" size="mini" @click="addNode(2)"
                :disabled="!Boolean(currentData.id) || currentData.type == 2">+下级</el-button>
              <el-button type="danger" size="mini" @click="deleteItem" :disabled="!Boolean(currentData.id)">删除
              </el-button>
              <el-button type="text" size="mini" @click="goBack">返回</el-button>
            </div>
            <div class="group-btn" v-else>
              <el-button type="primary" size="mini" @click="addNode(0)">+下级节点</el-button>
            </div>
            <!-- <catalog-tree @on-choose="setItem" :dataSource="menu"> </catalog-tree> -->
            <!-- @node-click="handleNodeClick" -->
            <el-tree ref="treeRef" :data="menu" node-key="id" default-expand-all @node-drag-start="handleDragStart"
              @node-drag-enter="handleDragEnter" @node-drag-leave="handleDragLeave" @node-drag-over="handleDragOver"
              @node-drag-end="handleDragEnd" @node-drop="handleDrop" draggable :allow-drop="allowDrop"
              :allow-drag="allowDrag" :current-node-key="currentKey" icon-class="none">
              <div class="custom-tree-node" slot-scope="{ node, data }">
                <i class="svgIconc" v-if="data.type == 2"></i>
                <span class="svgIconc-icon" v-else>
                  <i class="svgIconb" v-show="!data.fold" @click="handleFold(data, true)"></i>
                  <i class="svgIcona" v-show="data.fold" @click="handleFold(data, false)"></i>
                </span>
                <span class="label-name" v-show="!data.fold" @click="nodeClick(data, true)"
                  :title="node.label || '-'">{{ node.label }}</span>
                <span class="label-name" v-show="data.fold" @click="nodeClick(data, false)"
                  :title="node.label || '-'">{{ node.label }}</span>
              </div>
            </el-tree>
          </div>
          <div class="right-content">
            <template v-if="currentData.id">
              <div class="top" style="padding-bottom: 20px;text-align: right;">
                <el-button type="primary" size="small" @click="saveItem">保存</el-button>
              </div>
              <div class="bottom">
                <el-form ref="form" :model="currentData" label-width="130px" size="medium" label-position="left">
                  <el-form-item label="章节编号">
                    <el-input v-model.trim="currentData.chapterNo" :disabled="true"></el-input>
                  </el-form-item>
                  <!-- :disabled="true" -->
                  <el-form-item label="教程名称">
                    <el-input v-model.trim="currentData.name" maxlength="50" show-word-limit></el-input>
                  </el-form-item>

                  <el-form-item label="章节摘要">
                    <el-input type="textarea" :row="2" v-model="currentData.description"></el-input>
                  </el-form-item>
                  <el-form-item label="特征标签" style="margin:0 !important;">
                    <el-input v-model="currentData.tag"></el-input>
                  </el-form-item>
                  <el-form-item label="" style="margin:20px 0!important;" v-if="currentData.type == 2">
                    <div style="display:flex">
                      <div style="width:102px">
                        <el-button class="push-btn" size="small" type="primary" @click="associatedPush">+ 关联推送
                        </el-button>
                      </div>
                      <div style="flex:1" class="push-content">
                        <div class="push-data">
                          <!-- <el-tag closable>
                      问卷标题质量调研
                    </el-tag> -->
                          <!-- 问卷 -->
                          <el-tag class="qs-tag" v-for="(info1, index1) in questionData" :key="'questionData' + index1"
                            closable :title="info1.title" @close="closeQuestionTag(index1)">
                            {{
                              info1.title.length > 8
                                ? info1.title.substring(0, 8) + "..."
                                : info1.title
                            }}
                          </el-tag>
                          <!-- 宣教 -->
                          <el-tag class="article-tag" v-for="(info, index2) in articleData"
                            :key="'articleData' + index2" closable :title="info.title" @close="closeArticleTag(index2)">
                            {{
                              info.title.length > 8
                                ? info.title.substring(0, 8) + "..."
                                : info.title
                            }}
                          </el-tag>
                          <el-tag class="training-tag" closable v-for="(info, index3) in addtrainingTutorial"
                            :key="'addtrainingTutorial' + index3" :title="info.courseName"
                            @click.stop="showModelSelect(info)" @close="closetrainingTag(index3)">
                            <span :title="info[0].courseName">{{
                              info[0].courseName.length > 8
                                ? info[0].courseName.substring(0, 8) + "..."
                                : info[0].courseName
                              }}：</span>
                            <span class="course-chapter">内容 x{{ info.length }}</span>
                          </el-tag>

                          <span class="to-im">至IM、健康推荐</span>
                        </div>
                        <div class="im-notice">
                          <span>IM提醒：</span>
                          <el-input size="small" maxlength="300" show-word-limit v-model.trim="noticeText"></el-input>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="内容编辑" v-show="currentData.type == 2">
                    <!-- <div id="reain-editor"></div> -->
                    <wangeditorNew :formData="currentData" :index="0" :audioShow="true" :isCheck="isCheck"
                      v-if="isCheck" @content="contentChange"></wangeditorNew>
                  </el-form-item>
                  <div class="second-wrap" style="text-align: center;margin-bottom:20px;"
                    v-show="currentData.type == 2">
                    <el-button type='primary' size='small' style="margin-left: 20px;"
                      @click="identificationClick">识别当前文本内容
                    </el-button>
                  </div>
                  <div class="second-wrap " v-show="currentData.type == 2">
                    <el-form-item label="语音播报内容">
                      <el-input type="textarea" placeholder="" :rows="20" resize="none" maxlength="5000" show-word-limit
                        v-model="currentData.voiceReportContent" @input="textInput">
                      </el-input>
                      <div
                        style="border:1px solid #c0c4cc;border-top:none;display:flex;align-items: center;padding:10px 0;">
                        <el-button type='primary' size='small' style="margin:0 20px;" :disabled="!btnFlag" @click="getLatest">获取最新语音
                        </el-button>
                        <div class="audio-box" style="position:relative;height:54px;">
                          <audio controls="controls" v-if="currentData.voiceReportUrl" ref="myaudios"
                            :src="currentData.voiceReportUrl">
                          </audio>
                          <div class="audio-text" v-if="loadFlag">生成中...</div>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                  <div class="second-wrap" v-show="currentData.type == 2">
                    <el-form-item label="是否使用播报内容">
                      <el-radio v-model="currentData.voiceReport" :label="true"
                        :disabled="currentData.voiceReportContent == '' || currentData.voiceReportContent == null"
                        @change="whetherUseChange">是</el-radio>
                      <el-radio v-model="currentData.voiceReport" :label="false" @change="whetherUseChange">否</el-radio>
                    </el-form-item>
                  </div>
                </el-form>
              </div>
            </template>
            <template v-else>
              <p>暂无数据</p>
            </template>
          </div>
        </div>
      </div>
      <el-dialog title="新增教程章节" :visible.sync="dialogVisible" width="30%" style="z-index:100003;" @close="resetItem">
        <el-form ref="form" :model="newItem" label-width="80px" size="medium">
          <el-form-item label="章节编号">
            <el-input v-model="newItem.chapterNo" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="章节名称">
            <el-input type="textarea" placeholder="请输入" maxlength="50" show-word-limit
              :autosize="{ minRows: 2, maxRows: 7 }" v-model.trim="newItem.name"></el-input>
          </el-form-item>
          <el-form-item label="节点类型">
            <el-radio-group v-model="newItem.type" size="small">
              <el-radio-button label="1"> 目录</el-radio-button>
              <el-radio-button label="2"> 章节内容</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <!-- <div slot="footer">
          <el-button @click="cancel" size="small">取消</el-button>
          <el-button type="primary" size="small" @click="confirm"
            >创建</el-button
          >
        </div> -->
        </el-form>
        <div slot="footer" style="text-align:center;">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="confirm">创建</el-button>
        </div>
      </el-dialog>
      <!--  -->
      <RelatePushDialog v-if="showContentDialog" :showContentDialog.sync="showContentDialog"
        :notDisplayQuestionList="notDisplayQuestionList" :notDisplayArticleArr="notDisplayArticleArr"
        @receivePushData="receivePushData" />
    </div>
</template>

<script>
import local from "@/utils/local.js";
import axios from "axios";
import CatalogTree from "@/components/catalog-tree/Root";
import wangeditorNew from '@/components/wangeditorNew/index.vue'
import _ from "lodash";
import { changeChapterNo } from "@/api/course";
import { saveBatch, deleteChapter } from "@/api/questionnaireManage";
import { recognizeContent, getVoiceReport, taskId } from "@/api/ManagementPlan";
import RelatePushDialog from "@/components/RelatePushDialog.vue";
import $store from "@/store";
export default {
  components: {
    CatalogTree,
    wangeditorNew,
    RelatePushDialog
  },
  data() {
    return {
      menu: [],
      currentData: {
        voiceReport: false, //是否关联症状 1是     0否
        voiceReportContent: "",
        voiceReportUrl: ""
      },
      editor: null,
      dialogVisible: false,
      addType: 0,
      newItem: {
        chapterNo: "",
        name: "",
        type: "1"
        // tag: '',
        // description: ''
      },
      textArr: [1, 2, 2, 2, 2, 2, 2],
      defaultProps: {
        children: "children",
        label: "label"
      },
      checked1: true,
      checked2: true,
      obj: {}, //上个页面过来的搜索参数
      treeId: null, //拖拽id
      chapterCount: null,
      showContentDialog: false,
      chapterId: null,
      questionData: [],
      articleData: [],
      addtrainingTutorial: [],
      noticeText: "",
      questionnaireList: [], //问卷
      missionList: [], //宣教
      trainingList: [], //培训教程
      associatedPushList: [],
      treeList: [],
      notDisplayQuestionList: [],
      notDisplayArticleArr: [],
      flagBtn1: false,
      flagBtn2: false,
      currentKey: null,
      newFlag: false,
      Authorization: localStorage.getItem("Authorization").split(" ")[1],
      baseUrl: process.env.VUE_APP_API_MEDKB_URL,
      CLIENT_ID: process.env.VUE_APP_API_CLIENT_ID,
      mp3url: "",
      itemId: "",
      timer: null,
      voiceReportContentFlag: false,
      btnFlag: false,
      loadFlag: false,
      taskId: null,
      isCheck: true,
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    }
  },
  created() {
    clearInterval(this.timer);
    if (this.$route.query.obj) {
      this.obj = this.$route.query.obj;
    }
    if (JSON.stringify(this.$route.params) != "{}") {
      this.listQuery = this.$route.params.qsCondition;
      // this.listQuery.current = this.$route.params.qsCondition.current
    }
    var arr = [
      { name: "syy", age: "0" },
      { name: "wxy", age: "18" },
      { name: "slj", age: "8" },
      { name: "wj", age: "20" }
    ];

    // 排序方法
    function compare(property) {
      //property:根据什么属性排序
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        /*
         * value2 - value1; ——> 降序
         * value1 - value2; ——> 升序
         */
        return value1 - value2; //升序排序
      };
    }

    // 打印排序后的数组
  },
  mounted() {
    if (this.id) {
      this.getData();
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  //   beforeRouteLeave(to, from, next) {
  //     //设置下一个路由的meta,让列表页面缓存,即不刷新
  //     to.meta.keepAlive = true;
  //     next();
  //   },
  methods: {
    handleFold(obj, flag) {
      console.log(obj, "obj");
      if (obj.subChapters && obj.subChapters.length > 0) {
        if (obj.fold === undefined) {
          this.$set(obj, "fold", flag);
        } else {
          obj.fold = flag;
        }
      }
    },
    fn(arr) {
      return arr.filter((item, index, arr) => arr.indexOf(item) === index);
    },
    getData() {
      this.menu = [];
      axios
        .get("admin/train-chapter/tree", {
          params: {
            courseId: this.id
          }
        })
        .then(resp => {
          let data = resp.data;
          //   this.menu = data.data;
          //   return;
          // chapters
          //   let list = [];

          if (
            resp.data.data.subChapters &&
            resp.data.data.subChapters.length > 0
          ) {
            this.treeList = resp.data.data.subChapters;
            // let list = data.data.subChapters;
            let list = [];
            let arr = [];
            let obj = resp.data.data;
            obj.children = obj.subChapters;
            obj.label = obj.name;
            arr[0] = obj;
            list = arr;

            let toolFun = obj => {
              obj.forEach((item, index) => {
                item.children = item.subChapters
                  ? item.subChapters
                  : item.chapters;
                item.label = item.chapterNo + "_" + item.name;
                if (item.chapters && item.chapters.length > 0) {
                  item.chapters.forEach((el, i) => {
                    el.children = el.subChapters ? el.subChapters : el.chapters;
                    item.label = item.chapterNo + "_" + item.name;
                  });
                  toolFun(item.chapters);
                }
                if (item.subChapters && item.subChapters.length > 0) {
                  item.subChapters.forEach((el, i) => {
                    el.children = el.chapters ? el.chapters : el.subChapters;
                    el.label = el.chapterNo
                      ? item.chapterNo
                      : "" + "_" + el.name;
                  });
                  toolFun(item.subChapters);
                }
              });
            };
            toolFun(list[0].subChapters);
            this.menu = list;
          } else {
            let arr = [];
            let list = [];
            // list = data.data.subChapters;
            this.treeList = resp.data.data.subChapters;
            let obj = resp.data.data;
            obj.children = obj.subChapters;
            obj.label = obj.name;
            arr[0] = obj;
            list = arr;
            this.menu = list;
          }
          if (this.currentData.id) {
            this.$nextTick(() => {
              this.currentKey = this.currentData.id;
              this.$refs["treeRef"].setCurrentKey(this.currentKey);
            });
          }
          //   return;
        });
    },
    // setItem(val) {
    //   axios.get("admin/train-chapter/" + val.id).then(resp => {
    //     let data = resp.data;
    //     this.currentData = data.data;
    //   });
    // },
    saveItem() {
      //   return;
      if (this.flagBtn1) {
        return false;
      }

      if (
        (!this.currentData.content || this.currentData.content.trim() == "") &&
        this.currentData.type == 2
      ) {
        return this.$message.error("编辑内容不可为空，填写后保存");
        // this.flagBtn1 = false
      }
      let list = this.questionData.concat(
        this.articleData,
        this.addtrainingTutorial
      ); //问卷 宣教 培训教程 三个数组合在一起associatedPushList
      //   let params = {};
      //   params.list = list.map((item, index) => {
      //     return {
      //       pushRefId: item.pushRefId,
      //       pushType: item.pushType
      //     };
      //   });
      //   params.refId = this.currentData.id;
      //   params.refType = 4;
      let params = {
        pushMessage: this.noticeText,
        pushType: 0
      };
      let paramsObj = {};
      let obj = {
        chapterNo: this.$xss(this.currentData.chapterNo) || "",
        content: this.currentData.content || "",
        name: this.$xss(this.currentData.name) || "",
        tag: this.currentData.tag || "",
        description: this.$xss(this.currentData.description) || "",
        id: this.currentData.id,
        refType: 4,
        voiceReport: this.currentData.voiceReport, //是否关联症状 1是     0否
        voiceReportContent: this.currentData.voiceReportContent,
        voiceTaskId: this.taskId
      };
      paramsObj.list = this.associatedPushList.map((item, index) => {
        return {
          pushRefId: item.pushRefId,
          pushType: item.pushType
        };
      });
      (paramsObj.refId = this.currentData.id), (paramsObj.refType = 4);
      if (this.noticeText != "" && this.noticeText != null) {
        paramsObj.list.push(params);
      }

      paramsObj.list.forEach((item, index) => {
        console.log(item.pushRefId, "item");
        if (item.pushType == 0 && item.pushMessage == null) {
          //IM提醒
          paramsObj.list.splice(index, 1);
        }
      });
      let results = paramsObj.list.filter(element => {
        if (Object.keys(element).length !== 0) {
          return true;
        }
        return false;
      });
      paramsObj.list = results
      console.log(paramsObj, "paramsObj");
      obj.relatePushSaveBatchDTO = paramsObj;
      //   return;
      this.flagBtn1 = true;
      axios
        .put("admin/train-chapter", obj)
        .then(resp => {
          let data = resp.data;
          this.flagBtn1 = false;
          if (data.success) {
            this.$message.success("编辑成功");
            this.getData();
          }
          console.log("success");
        })
        .catch(res => {
          console.log("actch");
          this.flagBtn1 = false;
        });
      console.log(this.flagBtn1, "zuihou ");
    },
    deleteItem() {
      this.$confirm("是否要删除该章节", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      }).then(() => {
        deleteChapter({
          id: this.currentData.id
        }).then(resp => {
          let data = resp.data;
          if (resp.code == 0) {
            this.$message.success("删除成功");
            let arrParmentsParams = {};
            let toolForFun = (arr, id) => {
              //递归获取删除节点的父级
              arr.forEach((item, index) => {
                if (item.children && item.children.length > 0) {
                  item.children.forEach((el, index) => {
                    if (el.id == id) {
                      arrParmentsParams = item;
                    }
                    if (el.children && el.children.length > 0) {
                      el.children.forEach((an, n) => {
                        if (an.id == id) {
                          arrParmentsParams = el;
                        }
                      });
                      toolForFun(el.children, id);
                    }
                  });
                }
              });
            };
            toolForFun(this.menu, this.currentData.id); //获取删除节点的父级
            axios
              .get("admin/train-chapter/tree", {
                params: {
                  courseId: this.id
                }
              })
              .then(resp => {
                let menu = [];
                if (
                  resp.data.data.subChapters &&
                  resp.data.data.subChapters.length > 0
                ) {
                  this.treeList = resp.data.data.subChapters;
                  // let list = data.data.subChapters;
                  let list = [];
                  let arr = [];
                  let obj = resp.data.data;
                  obj.children = obj.subChapters;
                  obj.label = obj.name;
                  arr[0] = obj;
                  list = arr;

                  let toolFun = obj => {
                    obj.forEach((item, index) => {
                      item.children = item.subChapters
                        ? item.subChapters
                        : item.chapters;
                      item.label = item.chapterNo + "_" + item.name;
                      if (item.chapters && item.chapters.length > 0) {
                        item.chapters.forEach((el, i) => {
                          el.children = el.subChapters
                            ? el.subChapters
                            : el.chapters;
                          item.label = item.chapterNo + "_" + item.name;
                        });
                        toolFun(item.chapters);
                      }
                      if (item.subChapters && item.subChapters.length > 0) {
                        item.subChapters.forEach((el, i) => {
                          el.children = el.chapters
                            ? el.chapters
                            : el.subChapters;
                          el.label = el.chapterNo
                            ? item.chapterNo
                            : "" + "_" + el.name;
                        });
                        toolFun(item.subChapters);
                      }
                    });
                  };
                  toolFun(list[0].subChapters);
                  menu = list;
                } else {
                  let arr = [];
                  let list = [];
                  // list = data.data.subChapters;
                  this.treeList = resp.data.data.subChapters;
                  let obj = resp.data.data;
                  obj.children = obj.subChapters;
                  obj.label = obj.name;
                  arr[0] = obj;
                  list = arr;
                  menu = list;
                }
                //   menu = list;
                let arrParams = {};
                let toolForFun = (arr, id) => {
                  //删除节点的父节点递归
                  arr.forEach((item, index) => {
                    if (item.id == id) {
                      arrParams = item;
                    }
                    if (item.children && item.children.length > 0) {
                      item.children.forEach((el, index) => {
                        if (el.id == id) {
                          arrParams = el;
                        }
                        if (el.children && el.children.length > 0) {
                          el.children.forEach((an, n) => {
                            if (an.id == id) {
                              arrParams = an;
                            }
                          });
                          toolForFun(el.children, id);
                        }
                      });
                    }
                  });
                };
                toolForFun(menu, arrParmentsParams.id);
                let arrayParams = [];
                arrayParams.push(arrParams);
                let chapterNoSort = arr => {
                  //前端操作筛选后的排序
                  arr.forEach((item, index) => {
                    //   item.chapterNo = numSort(item.chapterNo, index);
                    if (item.subChapters && item.subChapters.length > 0) {
                      item.subChapters.forEach((el, i) => {
                        el.chapterNo = numSort(item.chapterNo, 0, i);
                        if (el.subChapters && el.subChapters.length > 0) {
                          el.subChapters.forEach((an, n) => {
                            an.chapterNo = numSort(el.chapterNo, 1, n);
                          });
                        }
                        chapterNoSort(el.subChapters);
                      });
                    }
                  });
                };
                let numSort = (num, type, index) => {
                  //数组排序的chapterNo序号
                  if (type == 0) {
                    let str = null;
                    if (num) {
                      str = num + "." + Number(index + 1);
                    } else {
                      str = Number(index + 1);
                    }
                    return str;
                    //   let str = num + "." + Number(index + 1);
                    //   return str;
                  } else {
                    let str = num.toString().split(".");
                    let lastNum =
                      Number(str[str.length - 1]) + "." + (index + 1);
                    str[str.length - 1] = lastNum;
                    let sum = str.join(".");
                    return sum;
                  }
                };
                chapterNoSort(arrayParams);
                let paramsObj = arrayParams[0];
                changeChapterNo(paramsObj).then(res => {
                  if (res.code == 0) {
                    this.currentData = {};
                    this.getData();
                  }
                });
              });
          }
        });
      });
    },
    resetItem() {
      for (let x in this.newItem) {
        this.newItem[x] = "";
      }
      this.newItem.type = "1";
    },
    uploadVideoError(xhr, editor, resData) { },
    addNode(type) {
      if (type == 0) {
        //下级节点
        this.newItem.chapterNo = 1;
      } else {
        let objParams = {};
        let toolForFun = (arr, ids) => {
          //筛选到当前拖动的父级对象
          arr.forEach((item, index) => {
            if (item.subChapters && item.subChapters.length > 0) {
              // objParams = {};
              item.subChapters.forEach((el, index) => {
                if (el.id == ids) {
                  objParams = item;
                }
                if (el.subChapters && el.subChapters.length > 0) {
                  el.subChapters.forEach((an, n) => {
                    if (an.id == ids) {
                      objParams = el;
                    }
                  });
                  toolForFun(el.subChapters, ids);
                }
              });
            }
          });
        };
        toolForFun(this.menu, this.currentData.id);
        if (type == 1) {
          //同级
          this.newItem.chapterNo = this.numberFun(
            this.currentData.chapterNo,
            objParams.chapterCount,
            1
          );
        } else if (type == 2) {
          //下级
          this.newItem.chapterNo = this.numberFun(
            this.currentData.chapterNo,
            this.chapterCount,
            2
          );
        }
      }
      this.addType = type;
      this.dialogVisible = true;
    },
    cancel() {
      this.dialogVisible = false;
    },
    confirm() {
      if (this.flagBtn2) {
        return false;
      }
      this.flagBtn2 = true;
      let obj = _.cloneDeep(this.newItem);
      if (this.addType == 0) {
        obj.level = 1;
        obj.nodeType = 2;
        obj.id = this.id;
      } else if (this.addType == 2) {
        obj.level = 2;
        obj.nodeType = 2;
        obj.id = this.currentData.id;
      } else {
        obj.nodeType = 1;
        obj.id = this.currentData.id;
      }
      axios
        .put("admin/train-chapter/addNode", obj)
        .then(resp => {
          this.flagBtn2 = false;
          let data = resp.data;
          if (data.success) {
            this.$message.success("创建成功");

            this.dialogVisible = false;
            this.currentData = {};
            this.getData();
            //   this.menu = data.data;
          } else {
            // this.$message.success(res.message);
          }
        })
        .catch(res => {
          this.flagBtn2 = false;
          this.$message.success(res.message);
        });
    },
    goBack() {
      // let listQsQuery = local.get("listQsQuery");
      // this.$router.push({
      //   name: 'questionnaireManage',
      //   params: {
      //     qsCondition: JSON.parse(listQsQuery)
      //   }
      // })
      let listQsQuery = local.get("listQsQuery1");
      this.$router.push({
        name: "courseList",
        params: {
          qsCondition: JSON.parse(listQsQuery)
        }
        //   query: {
        //     obj: this.obj
        //   }
      });
    },
    associatedPush() {
      this.showContentDialog = true;
      this.$store.commit("course_Id", null);
      this.notDisplayQuestionList = this.questionData;
      this.notDisplayArticleArr = this.articleData;
    },
    numberFun(num, chapterCount, type) {
      if (type == 1) {
        //同级
        let str = num.toString().split(".");
        let lastNum = Number(chapterCount + 1);
        str[str.length - 1] = lastNum;
        let sum = str.join(".");
        return sum;
      } else {
        //下级
        let str = num + "." + Number(chapterCount + 1);
        return str;
      }
    },
    handleDragStart(node, ev) {
      this.treeId = node.data.id;
    },
    handleDragEnter(draggingNode, dropNode, ev) { },
    handleDragLeave(draggingNode, dropNode, ev) { },
    handleDragOver(draggingNode, dropNode, ev) { },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      let arrParams = {};
      let toolForFun = (arr, id) => {
        //筛选到当前拖动的父级对象
        arr.forEach((item, index) => {
          //   if (item.id == id) {
          //     arrParams = arr;
          //   }
          if (item.children && item.children.length > 0) {
            item.children.forEach((el, index) => {
              if (el.id == id) {
                arrParams = item;
              }
              if (el.children && el.children.length > 0) {
                el.children.forEach((an, n) => {
                  if (an.id == id) {
                    arrParams = el;
                  }
                });
                toolForFun(el.children, id);
              }
            });
          }
        });
      };
      toolForFun(this.menu, this.treeId);
      let arrayParams = [];
      arrayParams.push(arrParams);
      let chapterNoSort = arr => {
        //前端操作筛选后的排序
        arr.forEach((item, index) => {
          //   item.chapterNo = numSort(item.chapterNo, index);
          if (item.subChapters && item.subChapters.length > 0) {
            item.subChapters.forEach((el, i) => {
              el.chapterNo = numSort(item.chapterNo, 0, i);
              if (el.subChapters && el.subChapters.length > 0) {
                el.subChapters.forEach((an, n) => {
                  an.chapterNo = numSort(el.chapterNo, 1, n);
                });
              }
              chapterNoSort(el.subChapters);
            });
          }
        });
      };
      let numSort = (num, type, index) => {
        //数组排序的chapterNo序号
        if (type == 0) {
          let str = null;
          if (num) {
            str = num + "." + Number(index + 1);
          } else {
            str = Number(index + 1);
          }
          return str;
        } else {
          let str = num.toString().split(".");
          let lastNum = Number(str[str.length - 1]) + "." + (index + 1);
          str[str.length - 1] = lastNum;
          let sum = str.join(".");
          return sum;
        }
      };

      chapterNoSort(arrayParams);
      let paramsObj = arrayParams[0];
      changeChapterNo(paramsObj).then(res => {
        if (res.code == 0) {
          this.getData();
        }
      });
    },
    handleDrop(draggingNode, dropNode, dropType, ev) { },
    allowDrag(draggingNode, dropNode, type) {
      return draggingNode.data.label.indexOf("三级 3-2-2") === -1;
    },
    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.level === dropNode.level) {
        if (draggingNode.parent.id === dropNode.parent.id) {
          // 向上拖拽 || 向下拖拽
          return type === "prev" || type === "next";
        }
      } else {
        // 不同级进行处理
        return false;
      }
    },
    sort(draggingNode, dropNode, type, event) {
      //  拖拽之后的重新组合的数组
      let obj = {
        aboveId: "",
        arr: []
      };
      obj.aboveId = dropNode.data.aboveId;
      for (let item of dropNode.parent.childNodes) {
        obj.arr.push(item.data.id);
      }
    },
    // handleNodeClick(item) {
    nodeClick(item, flag) {
      this.isCheck = false
      if (item.subChapters && item.subChapters.length > 0) {
        if (item.fold === undefined) {
          this.$set(item, "fold", flag);
        } else {
          item.fold = flag;
        }
      }
      this.chapterCount = item.chapterCount;
      this.questionData = [];
      this.articleData = [];
      this.$store.commit("chapter_ARR", []);
      this.associatedPushList = [];
      this.addtrainingTutorial = [];
      this.noticeText = null;
      console.log(item.id, "item.id");
      this.itemId = item.id;
      clearInterval(this.timer);
      axios.get("admin/train-chapter/" + item.id).then(resp => {
        console.log(resp, "resp");
        if (resp.data.code == 0) {
          if (this.editor) {
            this.editor.destroy();
          }
          if (resp.data.data) {
            let data = resp.data;
            this.currentData = data.data;
            console.log(data, "data.voiceReportContent");
            if (data.data.voiceReportContent) {
              this.btnFlag = true;
            } else {
              this.btnFlag = false;
            }

            this.taskId = data.data.voiceTaskId;
            if (data.data.voiceTaskId) {
              taskId({ taskId: this.taskId })
                .then(res => {
                  if (res.code == 0) {
                    this.currentData.voiceReportUrl = res.data.ossUrl;
                    if (res.data.status == 2) {
                      this.loadFlag = false;
                      this.btnFlag = false;
                      clearInterval(this.timer);
                    } else {
                      this.loadFlag = true;
                    }
                  }
                })
                .catch(res => {
                  this.loadFlag = false;
                });
              this.timerRequest();
            }
            this.isCheck = true
            console.log(this.btnFlag, " this.btnFlag");
            this.chapterId = data.data.id;
            this.$store.commit("chapter_ID", data.data.id);
            this.$store.commit("ref_ID", data.data.id);
            this.$store.commit("ref_TYPE", 4);
            if (
              this.currentData.getRelatePushVOS &&
              this.currentData.getRelatePushVOS.length > 0
            ) {
              this.associatedPushList = this.currentData.getRelatePushVOS.map(
                (item, index) => {
                  return {
                    courseName: item.pushRefName ? item.pushRefName : "",
                    title: item.pushRefName ? item.pushRefName : "",
                    ...item
                  };
                }
              );
              let arrPushList = [];
              let arr = [];
              const removeDuplicateObj = arr => {
                let obj = {};
                arr = arr.reduce((newArr, next) => {
                  obj[next.pushRefId]
                    ? ""
                    : (obj[next.pushRefId] = true && newArr.push(next));
                  return newArr;
                }, []);
                return arr;
              };
              console.log();
              this.associatedPushList.forEach((item, index) => {
                if (item.pushType == 0 && item.pushMessage == null) {
                  //IM提醒
                  this.associatedPushList.splice(index, 1);
                } else if (item.pushType == 0 && item.pushMessage != null) {
                  //IM提醒
                  this.noticeText = item.pushMessage;
                } else if (item.pushType == 1) {
                  //问卷
                  this.questionData.push(item);
                } else if (item.pushType == 3) {
                  //宣教
                  this.articleData.push(item);
                } else if (item.pushType == 4) {
                  //培训
                  item.courseName = item.courseName
                    ? item.courseName
                    : item.pushRefName;

                  arr.push(item);
                  //   arrPushList = removeDuplicateObj(arr);
                  arrPushList = arr;

                  this.$store.commit("chapter_ARR", arrPushList);
                  //   arr = this.getSortList(arrPushList);
                  this.addtrainingTutorial = this.getSortList(arrPushList);
                }
              });
            } else {
              this.noticeText = "";
              this.questionData = [];
              this.articleData = [];
              this.addtrainingTutorial = [];
              this.$store.commit("chapter_ARR", []);
            }
          } else {
            this.currentData.id = null;
          }
        } else {
        }
      });
    },
    receivePushData(arr1, arr2, arr3) {
      this.$emit("update:showContentDialog", false);
      this.$store.commit("chapter_ARR", arr3);
      let courseArr = [];
      if (arr3.length) {
        courseArr = this.getSortList(arr3);
      }
      this.questionData = this.questionData.concat(arr1);
      this.articleData = this.articleData.concat(arr2);
      //   this.addtrainingTutorial = this.addtrainingTutorial.concat(courseArr);
      this.addtrainingTutorial = courseArr;

      //   let list = arr1.concat(arr2, arr3);
      let list = [].concat.apply(
        [],
        courseArr.concat(this.questionData, this.articleData)
      );
      this.associatedPushList = this.associatedPushList.concat(list);

      let newParamsArr = this.associatedPushList.concat(list);
      this.associatedPushList = this.fn(newParamsArr);

      let params = {};
      //   return;
      params.list = list.map((item, index) => {
        return {
          pushRefId: item.pushRefId,
          pushType: item.pushType
        };
      });
      params.refId = this.currentData.id;
      params.refType = 4;
      saveBatch(params).then(res => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
      });
    },
    closeQuestionTag(index) {
      this.questionData.splice(index, 1);
      this.associatedPushList = this.addtrainingTutorial.concat(
        this.questionData,
        this.articleData
      );
    },
    closeArticleTag(index) {
      this.articleData.splice(index, 1);
      this.associatedPushList = this.addtrainingTutorial.concat(
        this.questionData,
        this.articleData
      );
    },
    closetrainingTag(index) {
      this.addtrainingTutorial.splice(index, 1);

      let onearr = [].concat.apply([], this.addtrainingTutorial);

      this.associatedPushList = onearr.concat(
        this.questionData,
        this.articleData
      );
      console.log(this.addtrainingTutorial, "this.addtrainingTutorial");
      console.log(this.associatedPushList, "this.associatedPushList");

      this.$store.commit("chapter_ARR", onearr);
    },
    closePushTag(index) {
      this.associatedPushList.splice(index, 1);
    },
    getSortList(list) {
      const map = new Map();
      list.forEach((item, index, arr) => {
        if (!map.has(item.courseName)) {
          map.set(
            item.courseName,
            arr.filter(a => a.courseName == item.courseName)
          );
        }
      });
      return Array.from(map).map(item => [...item[1]]);
    },
    showModelSelect(info) {
      if (this.$store.state.userPlatForm == "organization") {
        //机构不能点击
        return false;
      }
      this.showContentDialog = true;
      this.notDisplayQuestionList = this.questionData;
      this.notDisplayArticleArr = this.articleData;
      this.$store.commit("course_Id", info[0].courseId);
    },
    referenceClick() {
      this.newFlag = true;
    },
    cancelAdd() {
      this.newFlag = false;
    },
    symptomsChange(e) {
      console.log(e, "ee");
    },
    whetherUseChange(e) {
      console.log(e, "ee");
    },
    getLatest() {
      this.btnFlag = false;
      this.loadFlag = true;
      clearInterval(this.timer);
      getVoiceReport({
        refId: this.itemId, //目标源数据ID
        content: this.currentData.voiceReportContent, //内容
        sourceType: "voice_report_train_course" //来源类型
      })
        .then(res => {
          if (res.code == 0) {
            if (res.data.taskId) {
              this.taskId = res.data.taskId;
              this.timerRequest();
            } else {
              this.$message.error("获取语音失败");
            }
          }
        })
        .catch(res => {
          this.loadFlag = false;
        });
    },
    identificationClick() {
      if (this.currentData.content.trim() == "") {
        this.$message.error("请先填写内容");
        return false;
      }
      // let content = this.currentData.content.replace(/<\/p>/g, "\n").replace(/<\/section>/g, "\n");
      let content = this.currentData.content;
      console.log(content, "content");
      recognizeContent({
        refId: this.itemId, //目标源数据ID
        // content: this.currentData.content.trim(), //内容
        content: content, //内容
        sourceType: "voice_report_train_course" //来源类型
      }).then(res => {
        if (res.code == 0) {
          this.currentData.voiceReportContent = res.data.content.substring(0, 5000).replace(/&nbsp;/g, "").replace(/&gt;/g, "").replace(/&lt;/g, "").replace(/&amp;/g, "");
          if (this.currentData.voiceReportContent != "") {
            this.btnFlag = true;
          } else {
            this.btnFlag = false;
            this.currentData.voiceReport = false;
          }
          console.log(
            this.currentData.voiceReport,
            "this.formData.voiceReport"
          );
        }
      });
    },
    textInput(e) {
      if (e.trim() != "") {
        this.btnFlag = true;
      } else {
        this.currentData.voiceReport = false;
        this.currentData.voiceReportContent = "";
        this.btnFlag = false;
      }
    },
    timerRequest() {
      this.timer = setInterval(() => {
        taskId({ taskId: this.taskId })
          .then(res => {
            if (res.code == 0) {
              this.currentData.voiceReportUrl = res.data.ossUrl;
              if (res.data.status == 2) {
                this.loadFlag = false;
                this.btnFlag = false;
                clearInterval(this.timer);
              } else {
                this.loadFlag = true;
              }
            }
          })
          .catch(res => {
            this.loadFlag = false;
          });
      }, 5000);
    },
    contentChange(content) {
      this.currentData.content = content.content
    },
  }
};
</script>


<style lang="less" scoped>
.audio-text {
  width: 300px;
  height: 54px;
  background: #f1f3f4;
  color: #a8aaaa;
  border-radius: 30px;
  text-align: center;
  line-height: 54px;
  position: absolute;
  left: 0;
  top: 0;
}

.indeterminate .el-checkbox__input .el-checkbox__inner {
  background-color: #409eff !important;

  border-color: #409eff !important;

  color: #fff !important;
}

.indeterminate .el-checkbox__input.is-checked .el-checkbox__inner::after {
  transform: scale(0.5);
}

.indeterminate .el-checkbox__input .el-checkbox__inner {
  background-color: #f2f6fc;

  border-color: #dcdfe6;
}

.indeterminate .el-checkbox__input .el-checkbox__inner::after {
  border-color: #c0c4cc !important;

  background-color: #c0c4cc;
}

.product-show th .el-checkbox__inner {
  display: none !important;
}

.indeterminate .el-checkbox__input .el-checkbox__inner::after {
  content: "";

  position: absolute;

  display: block;

  background-color: #fff;

  height: 2px;

  transform: scale(0.5);

  left: 0;

  right: 0;

  top: 5px;

  width: auto !important;
}

.product-show .el-checkbox__inner {
  display: block !important;
}

.product-show .el-checkbox {
  display: block !important;
}

.push-content {
  margin-left: 10px;

  .push-data {
    .to-im {
      font-size: 14px;
      color: #333333;
      line-height: 20px;
    }
  }

  .qs-tag {
    max-width: 144px;
    height: 28px;
    background: #eff6ff;
    border-radius: 16px;
    border: 1px solid #e9f2ff;
    margin-right: 10px;
    margin-bottom: 10px;
    line-height: 28px;
    font-size: 12px;
    color: #1a7bfc;
  }

  .article-tag {
    max-width: 144px;
    height: 28px;
    background: #eefff8;
    border-radius: 16px;
    border: 1px solid #eefff8;
    margin-right: 10px;
    margin-bottom: 10px;
    line-height: 28px;
    font-size: 12px;
    color: #00b570;

    /deep/.el-tag__close {
      color: #00b570;
    }

    /deep/.el-tag__close:hover {
      color: #ffffff;
      background-color: #00b570;
    }
  }

  .training-tag {
    max-width: 202px;
    height: 28px;
    background: #fff8ee;

    border-radius: 16px;
    border: 1px solid #fdf3e5;

    margin-right: 10px;
    margin-bottom: 10px;
    line-height: 28px;
    font-size: 12px;

    color: #dd8200;
    cursor: pointer;

    /deep/.el-tag__close {
      color: #dd8200;
    }

    /deep/.el-tag__close:hover {
      color: #ffffff;
      background-color: #dd8200;
    }
  }
}

.push-btn {
  width: 102px;
  height: 36px;
  margin-right: 10px;
}

.im-notice {
  //   margin-top: 10px;
  font-size: 14px;
  color: #333333;
  line-height: 22px;
  display: flex;
  align-items: center;

  span {
    display: block;
    width: 65px;
    text-align: right;
  }

  /deep/.el-input {
    flex: 1;
  }
}

.del-conclusion {
  margin-left: 20px;

  img {
    width: 24px;
    height: 24px;
  }
}

.editor-score {
  display: flex;
  margin-top: 20px;

  .editor-title {
    display: block;
    width: 60px;
    margin-right: 20px;
    text-align: right;
  }

  .score-range {
    display: inline-block;
    width: 60px;
    line-height: 36px;
    margin-right: 20px;
    text-align: right;
  }
}

.editor-noscore {
  display: flex;
  margin-top: 20px;

  .editor-title {
    display: block;
    width: 60px;
    margin-right: 20px;
    text-align: right;
  }

  div {
    flex: 1;
  }
}

.reain-detail-page {
  display: flex;
  height: 100%;

  .left-menu {
    width: 300px;
    border-right: 1px solid #ccc;
    padding: 10px;
    overflow: auto;

    .group-btn {
      margin-bottom: 20px;
    }
  }

  .right-content {
    width: 100%;
    flex: 1;
    padding: 0 20px;
    overflow: auto;

    p {
      width: 100%;
      height: 100%;
      text-align: center;
      line-height: 400px;
      font-size: 14px;
    }
  }
}

.associated-push-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 10px 0;

  //   .associated-box {
  //     display: flex;
  //     align-items: center;
  .associated-box-item {
    width: 140px;
    height: 28px;
    border-radius: 16px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 16px 10px 0;

    img {
      width: 16px;
      height: 16px;
      margin: 0 0 0 8px;
      cursor: pointer;
    }
  }

  .blue {
    background: #eff6ff;
    border: 1px solid #e9f2ff;
    color: #1a7bfc;
  }

  .green {
    background: #eefff8;
    border: 1px solid #eafbf4;
    color: #00b570;
  }

  .green {
    background: #fff8ee;
    border: 1px solid #fdf3e5;
    color: #dd8200;
  }

  .textim {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin: 0 0 0 -6px;
  }

  //   }
}

.mr16 {
  margin: 0 16px 0 0;
}

.inline {
  display: inline-block;
}

.fr {
  float: right;
}

.mt8 {
  margin: 8px 0 0 0;
}

.checked-span {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

/deep/.el-textarea__inner {
  padding-bottom: 25px;
  min-height: auto !important;
  resize: none;
}

/deep/ .el-textarea .el-input__count {
  height: 20px;
  line-height: 20px;
  background: none;
  right: 18px;
}

// .fl {
//   float: left;
// }
.el-tree /deep/ .el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

//有子节点 且未展开
// .el-tree /deep/ .el-icon-caret-right:before {
//   background: url(../../assets/images/folder.png) no-repeat 0 3px;
//   content: "";
//   display: block;
//   width: 26px;
//   height: 26px;
//   font-size: 16px;
//   background-size: 20px;
// }
// //有子节点 且已展开
// .el-tree /deep/ .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
//   background: url(../../assets/images/folderOpen.png) no-repeat 0 3px;
//   content: "";
//   display: block;
//   width: 26px;
//   height: 26px;
//   font-size: 16px;
//   background-size: 20px;
// }
// //没有子节点
// .el-tree /deep/.el-tree-node__expand-icon.is-leaf::before {
//   background: url(../../assets/images/file.png) no-repeat 0 3px;
//   content: "";
//   display: block;
//   width: 26px;
//   height: 26px;
//   font-size: 16px;
//   background-size: 20px;
// }

//父节点
.el-tree /deep/ .svgIcona {
  background: url(../../assets/images/folder.png) no-repeat 0 3px;
  content: "";
  display: block;
  width: 26px;
  height: 26px;
  font-size: 16px;
  background-size: 20px;
}

//目录
.el-tree /deep/ .svgIconb {
  background: url(../../assets/images/folderOpen.png) no-repeat 0 3px;
  content: "";
  display: block;
  width: 26px;
  height: 26px;
  font-size: 16px;
  background-size: 20px;
}

//章节
.el-tree /deep/ .svgIconc {
  background: url(../../assets/images/file.png) no-repeat 0 3px;
  content: "";
  display: block;
  width: 26px;
  height: 26px;
  font-size: 16px;
  background-size: 20px;
}

//有子节点 且已展开
.el-tree /deep/ .el-tree-node__expand-icon.expanded.el-icon-caret-right .svgIconb {
  background: url(../../assets/images/folder.png) no-repeat 0 3px;
  content: "";
  display: block;
  width: 26px;
  height: 26px;
  font-size: 16px;
  background-size: 20px;
}

.el-tree /deep/ .el-tree-node__expand-icon.expanded.el-icon-caret-right .svgIconb {
  background: url(../../assets/images/folder.png) no-repeat 0 3px;
  content: "";
  display: block;
  width: 26px;
  height: 26px;
  font-size: 16px;
  background-size: 20px;
}

.el-tree /deep/.el-tree-node__label {
  font-size: 14px;
  float: left;
  width: 200px;
  margin: 3px 0 0 0;
  white-space: pre-line !important;
  word-break: break-all !important;
  word-wrap: break-word !important;
}

.el-tree /deep/.el-tree-node__expand-icon.is-leaf {
  float: left;
}

.el-tree /deep/.el-tree-node__expand-icon.expanded {
  float: left;
}

.el-tree /deep/.el-tree-node__content {
  //   display: block;
  min-width: 300px;
  height: auto;
  cursor: pointer;
  white-space: normal;
  align-items: inherit;
  overflow: hidden;
}

/deep/.el-tree-node>.el-tree-node__children {
  overflow: visible;
}

.el-tree /deep/.el-tree-node__content>.el-tree-node__expand-icon {
  padding: 0;
  float: left;
}

.el-tree /deep/.el-tree-node__content span {
  display: inline-block;
  float: left;
  line-height: 20px;
}

.el-tree /deep/ .is-current {
  color: #1a7bfc;
}

.el-tree /deep/ .is-current .el-tree-node__children {
  color: #606266;
}

.custom-tree-node {
  position: relative;
  width: 280px;
  display: flex;

  .svgIconc-icon {
    float: left;
  }

  .label-name {
    font-size: 14px;
    float: left;
    width: 236px;
    margin: 3px 0 0 0;
    white-space: pre-line !important;
    word-break: break-all !important;
    word-wrap: break-word !important;
  }

  //   .labelName {
  //     font-size: 14px;
  //     float: left;
  //     width: 200px;
  //     margin: 3px 0 0 0;
  //     white-space: pre-line !important;
  //     word-break: break-all !important;
  //     word-wrap: break-word !important;
  //   }
  //   .renameName {
  //     font-size: 14px;
  //     font-family: PingFangSC-Regular, PingFang SC;
  //     font-weight: 400;
  //     color: #1a7bfc;
  //     text-decoration: none;
  //     position: absolute;
  //     right: 0;
  //     top: 0;
  //   }
}

/deep/.push-content .el-input--small .el-input__inner {
  padding: 0 80px 0 15px !important;
}
</style>
<style lang="less">
.indeterminate .el-checkbox__input .el-checkbox__inner {
  background-color: #409eff !important;

  border-color: #409eff !important;

  color: #fff !important;
}

.indeterminate .el-checkbox__input.is-checked .el-checkbox__inner::after {
  transform: scale(0.5);
}

.indeterminate .el-checkbox__input .el-checkbox__inner {
  background-color: #f2f6fc;

  border-color: #dcdfe6;
}

.indeterminate .el-checkbox__input .el-checkbox__inner::after {
  border-color: #c0c4cc !important;

  background-color: #c0c4cc;
}

.product-show th .el-checkbox__inner {
  display: none !important;
}

.indeterminate .el-checkbox__input .el-checkbox__inner::after {
  content: "";

  position: absolute;

  display: block;

  background-color: #fff;

  height: 2px;

  transform: scale(0.5);

  left: 0;

  right: 0;

  top: 5px;

  width: auto !important;
}

.product-show .el-checkbox__inner {
  display: block !important;
}

.product-show .el-checkbox {
  display: block !important;
}

/deep/.v-modal {
  z-index: 100002 !important;
}

/deep/.w-e-toolbar {
  z-index: 3 !important;
}

/deep/.el-textarea__inner {
  padding-bottom: 25px;
  min-height: auto !important;
}

/deep/ .el-textarea .el-input__count {
  height: 20px;
  line-height: 20px;
  background: none;
  right: 18px;
}
</style>
